// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__e9CeL","label":"styles_label__TdVR6","icon":"styles_icon__5RzTF"};